import { puppeteerUniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/puppeteer';
import { default as InfiniteScrollTableUniDriver } from '../components/InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { InfiniteScrollCollectionListUniDriver } from '../components/InfiniteScrollCollectionList/InfiniteScrollCollectionList.uni.driver';
import PickerStandaloneUniDriver from '../components/PickerStandalone/PickerStandalone.uni.driver';
import { default as PickerModalUniDriver } from '../components/PickerModal/PickerModal.uni.driver';
import { CollectionViewsDropdownUniDriver } from '../components/CollectionViewsDropdown/CollectionViewsDropdown.uni.driver';
import { CollectionSaveViewModalUniDriver } from '../components/CollectionViewsDropdown/modals/SaveView/CollectionSaveViewModal.uni.driver';
import { CardsGridUniDriver } from '../components/Grid/CardsGrid.uni.driver';
import { TableGridSwitchUniDriver } from '../components/TableGridSwitch/TableGridSwitch.uni.driver';
import GridFoldersUniDriver from '../components/Grid/GridFolders.uni.driver';
import TableFoldersUniDriver from '../components/TableFolders/TableFolders.uni.driver';
import TableGridSwitchFoldersUniDriver from '../components/TableGridSwitchFolders/TableGridSwitchFolders.uni.driver';
import CustomFieldsWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsWidget.uni.driver';
import { NestedTableUniDriver } from '../components/NestedTable/NestedTable.uni.driver';
import CustomFieldsViewWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsViewWidget.uni.driver';
import EntityPageUniDriver from '../components/EntityPage/EntityPage.uni.driver';
import SkeletonCardUniDriver from '../components/SkeletonCard/SkeletonCard.uni.driver';
import ErrorCardUniDriver from '../components/ErrorCard/ErrorCard.uni.driver';
import PageErrorStateUniDriver from '../components/PageErrorState/PageErrorState.uni.driver';
import { ManageTagsModalUniDriver } from '../components/Tags/ManageTags/ManageTagsModal/ManageTagsModal.uni.driver';

export const InfiniteScrollTableTestkit = puppeteerUniTestkitFactoryCreator(
  InfiniteScrollTableUniDriver,
);

export const CardsGridTestkit =
  puppeteerUniTestkitFactoryCreator(CardsGridUniDriver);

export const CustomFieldsWidgetTestkit = puppeteerUniTestkitFactoryCreator(
  CustomFieldsWidgetUniDriver,
);

export const CustomFieldsViewWidgetTestkit = puppeteerUniTestkitFactoryCreator(
  CustomFieldsViewWidgetUniDriver,
);

export const TableGridSwitchTestkit = puppeteerUniTestkitFactoryCreator(
  TableGridSwitchUniDriver,
);

export const GridFoldersTestkit =
  puppeteerUniTestkitFactoryCreator(GridFoldersUniDriver);
export const TableFoldersTestkit = puppeteerUniTestkitFactoryCreator(
  TableFoldersUniDriver,
);
export const NestedTableTestkit =
  puppeteerUniTestkitFactoryCreator(NestedTableUniDriver);

export const TableGridSwitchFoldersTestkit = puppeteerUniTestkitFactoryCreator(
  TableGridSwitchFoldersUniDriver,
);

export const InfiniteScrollCollectionListTestkit =
  puppeteerUniTestkitFactoryCreator(InfiniteScrollCollectionListUniDriver);

export const PickerStandaloneTestkit = puppeteerUniTestkitFactoryCreator(
  PickerStandaloneUniDriver,
);

export const PickerModalTestkit =
  puppeteerUniTestkitFactoryCreator(PickerModalUniDriver);

export const ViewsStandaloneTestkit = puppeteerUniTestkitFactoryCreator(
  CollectionViewsDropdownUniDriver,
);

export const ViewsStandaloneSaveModalTestkit =
  puppeteerUniTestkitFactoryCreator(CollectionSaveViewModalUniDriver);

export const EntityPageTestkit =
  puppeteerUniTestkitFactoryCreator(EntityPageUniDriver);

export const SkeletonCardTestkit = puppeteerUniTestkitFactoryCreator(
  SkeletonCardUniDriver,
);
export const ErrorCardTestkit =
  puppeteerUniTestkitFactoryCreator(ErrorCardUniDriver);

export const PageErrorStateTestkit = puppeteerUniTestkitFactoryCreator(
  PageErrorStateUniDriver,
);

export const ManageTagsModalTestkit = puppeteerUniTestkitFactoryCreator(
  ManageTagsModalUniDriver,
);
